import React from "react";
import CoronaApp from "./components/CoronaApp";

function App() {
  return <CoronaApp />;
}
export default App;
